import { HttpService } from '@/infra/http'
import type { TTipoProdutoChileEnum, TTipoProdutoPrecificadoBrasilEnum } from '@/types/produto'

import type { TGetConfiguracoesPrecoResponse } from './get-configuracoes-preco.service'

export class GetProdutoDisponivelNovaSimulacaoEmpreendimentoService extends HttpService {
  execute = async (
    idExternoEmpreendimento: number,
    tipoDoProduto: TTipoProdutoPrecificadoBrasilEnum | TTipoProdutoChileEnum,
  ) => {
    return this.http.get<TGetConfiguracoesPrecoResponse>(
      `api/v2/Produto/disponivelNovaSimulacao/empreendimento/${idExternoEmpreendimento}/tipoDoProduto/${tipoDoProduto}`,
    )
  }
}
